import {
  TranslationRules,
  TranslationRulesId,
  Translations,
  TranslationOverrideType,
  TranslationRulesClient,
} from '@upstart/harmony/lib/legos/translationRulesTypes';
import BackendService from './BackendService';

export default class TranslationRulesService {
  static getAll(client?: TranslationRulesClient) {
    return BackendService.get(
      `/translationRules${client ? `?client=${client}` : ''}`,
    );
  }

  static get(translationRulesId: TranslationRulesId) {
    return BackendService.get(`/translationRules/${translationRulesId}`);
  }

  static create(translationRules: Partial<TranslationRules>) {
    return BackendService.post('/translationRules', {
      body: translationRules,
    });
  }

  static update(
    translationRules: Partial<TranslationRules>,
    overrides: Translations,
    overrideType: TranslationOverrideType,
  ) {
    return BackendService.put(`/translationRules/${translationRules.id}`, {
      body: { translationRules, overrides, overrideType },
    });
  }

  static delete(translationRulesId: TranslationRulesId) {
    return BackendService.delete(`/translationRules/${translationRulesId}`);
  }

  static getDefault(client = TranslationRulesClient.WEB) {
    return BackendService.get(`/translationRules/default?client=${client}`, {
      cache: true,
    });
  }
}
